// pages/PatientDocuments.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import DocumentUploadSection from "../components/patient/DocumentUploadSection";

export default function PatientDocuments() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 480,
        margin: "0 auto",
        padding: "16px",
      }}
    >
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            width: 32,
            height: 32,
            borderRadius: 999,
            border: "1px solid #E5E7EB",
            background: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ArrowLeft size={18} color="#4B5563" />
        </button>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <span style={{ fontSize: 16, fontWeight: 700, color: "#0F172A" }}>
            Dokumentet e mia
          </span>
          <span style={{ fontSize: 13, color: "#6B7280" }}>
            Këtu ruan analizat, epikrizat dhe raportet e tua në MikDok.
          </span>
        </div>
      </div>

      {/* Upload + list */}
      <div style={{ marginTop: 16 }}>
        <DocumentUploadSection hideTitle={true} />
      </div>
    </div>
  );
}
